import { Injectable } from "@angular/core";
import _ = require("lodash");
import { Observable } from "rxjs/Observable";
import { Subject } from "rxjs/Subject";
import "rxjs/add/operator/timeoutWith";
import { environment } from "../../../environments/environment";
import { FilterCriteria } from "../../models/filter-criteria";
import { ILimitedResult } from "../../models/limitedResult";
import { RemittanceEntry } from "../../models/remittance-entry.model";
import { BaseService } from "../api-base.service";
import { ReconApiService } from "../recon-api.service";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class RemittanceStageService {
  private readonly timeout: number = 30000;
  private readonly basePath: string = "Remittance";

  //  Observables
  private editRemittanceSource = new Subject<RemittanceEntry>();
  private deleteRemittanceSource = new Subject<RemittanceEntry>();

  editRemittanceSource$ = this.editRemittanceSource.asObservable();
  deleteRemittanceSource$ = this.deleteRemittanceSource.asObservable();

  constructor(
    private http: HttpClient,
    private apiBase: BaseService,
    private reconApiService: ReconApiService
  ) {}

  public async loadStagedRemittances(
    clientId: string,
    checkReferenceNumber: number,
    criteria: FilterCriteria,
    onlyInvalid: boolean = false
  ): Promise<ILimitedResult<RemittanceEntry>> {
    const url = `${environment.reconApiRoot.url}/client/${clientId}/${
      this.basePath
    }/Checks/${checkReferenceNumber}${criteria.toString()}&onlyInvalid=${onlyInvalid}`;

    const response = await this.http
      .get<ILimitedResult<RemittanceEntry>>(url, {
        headers: this.apiBase.getHeaders(),
      })
      .timeoutWith(
        this.timeout,
        Observable.throw(new Error("Timeout exceeded."))
      )
      .toPromise()
      .catch((error) => {
        console.log(
          `Error occurred at ${new Date()} status: ${
            error && error.status ? error.status.toString() : "unknown"
          }`
        );
        this.reconApiService.logToElasticSearchFromUI(
          error,
          url
        );
      });

    return response;
  }

  async deleteRemittance(clientId: string, remittance: RemittanceEntry) {
    //  Delete remittance entry on iSeries.
    await this.deleteRemittanceEntry(
      clientId,
      remittance.Payment_BatchId,
      remittance.Batch_SequenceNumber
    )
      .then(() => {
        //  Notify subscribers that a Remittance Entry has been deleted.
        this.deleteRemittanceSource.next(remittance);
      })
      .catch((error) => {
        console.log(
          `Error occurred at ${new Date()} status: ${
            error && error.status ? error.status.toString() : "unknown"
          }`
        );
      });
  }

  //  Updates the remittance to the iSeries.
  private async deleteRemittanceEntry(
    clientId: string,
    batchId: string,
    sequenceNum: number
  ) {
    const url = `${environment.reconApiRoot.url}/client/${clientId}/${this.basePath}/StageRemittances/Batch/${batchId}/Sequence/${sequenceNum}`;

    return this.http
      .delete(url, {
        headers: this.apiBase.getHeaders(),
      })
      .timeoutWith(
        this.timeout,
        Observable.throw(new Error("Timeout exceeded."))
      )
      .toPromise()
      .catch((error) => {
        console.log(
          `Error occurred at ${new Date()} status: ${
            error && error.status ? error.status.toString() : "unknown"
          }`
        );
        this.reconApiService.logToElasticSearchFromUI(error, url);
        // rethrow so deleteRemittance's .catch gets it
        throw error;
      });
  }

  public onEditRemittance(remittance: RemittanceEntry) {
    this.editRemittanceSource.next(remittance);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/remittance-entry/remittance-stage.service.ts